var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "oneGift" }, [
    _c("div", { staticClass: "pts" }, [
      _c("span", [_vm._v(_vm._s(_vm.giftPoints))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "vignette" }, [
      _vm.giftImage
        ? _c(
            "a",
            {
              attrs: {
                "data-toggle": "modal",
                "data-target": "#layerGift" + _vm.giftId
              }
            },
            [
              _c("img", {
                staticClass: "lazyload img-fluid",
                attrs: { "data-src": _vm.giftImage, alt: _vm.giftTitle }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("h3", [
      _c(
        "a",
        {
          attrs: {
            href: "",
            "data-toggle": "modal",
            "data-target": "#layerGift" + _vm.giftId
          }
        },
        [
          _vm._v("\n            " + _vm._s(_vm.giftTitle) + " "),
          _c("span", [_vm._v(_vm._s(_vm.giftSubtitle))])
        ]
      )
    ]),
    _vm._v(" "),
    _vm.showError
      ? _c("div", { staticClass: "alert alert-warning" }, [
          _vm._v("\n        Votre solde de points n’est pas suffisant\n    ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.connected
      ? _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.update()
              }
            }
          },
          [_vm._v("Ajouter au panier")]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "layerGift" + _vm.giftId,
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "exampleModalLabel",
          "aria-hidden": "true"
        }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h5",
                  {
                    staticClass: "modal-title",
                    attrs: { id: "exampleModalLabel" }
                  },
                  [_vm._v(_vm._s(_vm.giftTitle))]
                ),
                _vm._v(" "),
                _vm._m(0)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "pts" }, [
                  _c("span", [_vm._v(_vm._s(_vm.giftPoints))])
                ]),
                _vm._v(" "),
                _vm.giftImage
                  ? _c("img", {
                      staticClass: "lazyload img-fluid",
                      attrs: { "data-src": _vm.giftImage, alt: _vm.giftTitle }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.giftDescription) }
                }),
                _vm._v(" "),
                _vm.showError
                  ? _c("div", { staticClass: "alert alert-warning" }, [
                      _vm._v(
                        "\n                            Votre solde de points n’est pas suffisant\n                        "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.connected
                  ? _c("div", { staticClass: "text-center" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.update()
                            }
                          }
                        },
                        [_vm._v("Ajouter au panier")]
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6699a958", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6699a958","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/GiftCard.vue
// module id = 534
// module chunks = 1